import * as go from 'gojs'
import { layoutGroupSpacing, layoutNodeSpacingAdjustmentForBadge } from '@/utils/constants'

export default function VerticalLayout () {
  go.GridLayout.call(this)
  this.isViewportSized = false
}

go.Diagram.inherit(VerticalLayout, go.GridLayout)

VerticalLayout.prototype.doLayout = function (coll) {
  var ecoll = this.collectParts(coll)
  const parts = []
  ecoll.each(p => {
    parts.push(p)
  })
  parts.sort(this.comparer)
  const padding = this.group.placeholder.padding
  let topLeft = this.group.placeholder.getDocumentPoint(go.Spot.TopLeft)
  topLeft.x += padding.left
  topLeft.y += padding.top
  var spac = this.spacing
  let rowHeight = 0
  let x = topLeft.x
  let y = topLeft.y
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    if (p.data.isGroup) {
      y += layoutGroupSpacing
    }
    p.moveTo(x, y)
    rowHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
    y += rowHeight + spac.height
  })
}



// WEBPACK FOOTER //
// ./src/graph_parts/vertical_layout.js